export const Info = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.23633 3V5.1"
      stroke="#696969"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.23633 6.38281V6.42281"
      stroke="#696969"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.23633 8.70313C7.43633 8.70313 9.23633 6.90313 9.23633 4.70313C9.23633 2.50313 7.43633 0.703125 5.23633 0.703125C3.03633 0.703125 1.23633 2.50313 1.23633 4.70313C1.23633 6.90313 3.03633 8.70313 5.23633 8.70313Z"
      stroke="#696969"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
